import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { get } from 'lodash';
import { DropDown, Menu, MenuItem, Button } from 'src/components/Antd';
import { EnumStatus } from 'src/types/common/discount';
import css from './css.module.less';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TopRight = (props) => {
  const {
    hasModified,
    onSubmit,
    status,
    isNew,
    onDuplicate,
    onArchive,
    onPublish,
    onRestore,
    onDraft,
    isPrimary,
    disableEdit,
    disableDelete,
  } = props;
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const actionGenerator = () => {
    const overlay = (
      <Menu className={css.menu}>
        {!disableEdit && (
          <MenuItem className={css.menuItem} onClick={onDuplicate}>
            {getI18n('general.duplicate')}
          </MenuItem>
        )}
        {!disableDelete && (
          <MenuItem className={css.menuItemArchive} onClick={onArchive}>
            {getI18n('general.archive')}
          </MenuItem>
        )}
      </Menu>
    );

    if (status !== EnumStatus.Archived) {
      return (
        <div className={css.actionBtnContainer}>
          <DropDown.Button
            className={css.actionBtn}
            overlay={overlay}
            placement='bottomRight'
            trigger={['click']}>
            {getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            )}
          </DropDown.Button>
        </div>
      );
    }
  };

  const greenBtn = () => {
    if (status === EnumStatus.Draft) {
      return (
        <Button
          type='primary'
          className={css.greenBtn}
          onClick={onPublish}
          ghost>
          {getI18n('general.publish')}
        </Button>
      );
    }
    if (
      status === EnumStatus.Active ||
      status === EnumStatus.Scheduled ||
      status === EnumStatus.Expired
    ) {
      return (
        <Button type='primary' className={css.greenBtn} onClick={onDraft} ghost>
          {getI18n('general.switchToDraft')}
        </Button>
      );
    }
    if (status === EnumStatus.Archived) {
      return (
        <Button
          className={css.greenBtn}
          type='primary'
          onClick={onRestore}
          ghost>
          {getI18n('general.restore')}
        </Button>
      );
    }
  };
  const rightBtnGenerator = () => {
    if (isNew) {
      return null;
    }
    return (
      <React.Fragment>
        {actionGenerator()}
        {(!disableEdit || !disableDelete) && greenBtn()}
      </React.Fragment>
    );
  };

  const s = useParams();
  const salesChannelUuid = get(s, 'uuid');

  const h = useHistory();
  const onD = () => {
    h.push(`/salesChannel/discounts/subscriptionBuy/list/${salesChannelUuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified}
      onSubmit={onSubmit}
      extendButton={isPrimary ? rightBtnGenerator() : null}
      extraLeft={
        isNew ? null : (
          <div style={{ marginRight: 8 }}>
            <MultiLangDropDown
              customType={
                EnumMultiLanguageType.SalesChannelDiscountsSubscriptionBuy
              }
              hasModified={hasModified}
              salesChannelUuidKey='uuid'
            />
          </div>
        )
      }
    />
  );
};
export default TopRight;
